import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { IFrequencySlabs } from '../payment-sip/payment-sip.model';


@Component({
  selector: 'app-pledge-frequency-slab',
  templateUrl: './pledge-frequency-slab.component.html',
  styleUrls: ['./pledge-frequency-slab.component.scss']
})
export class PledgeFrequencySlabComponent implements OnInit {

  @Input() config: IFrequencySlabs;
  @Output() selectionEmit = new EventEmitter();
  @ViewChild('otherInput') otherInput: ElementRef<HTMLElement>;
  @ViewChild('manual_input') manualInput: ElementRef;
  slabsForm: FormGroup;
  show_input_label = true;

  constructor() { }


  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.slabsForm = new FormGroup({
      frequency: new FormControl(this.config.default_selected, [Validators.required, Validators.pattern(/^[0-9]+$/)]),
    });
  }

  setFrequency(f) {
    this.slabsForm.setValue({ frequency: +f });
    this.selectionEmit.emit(+f);
  }

  showOtherInput() {
    if (this.config?.manual_input_label) {
      this.show_input_label = false;
      this.otherInput.nativeElement.style.display = 'flex';
    }
    this.manualInput.nativeElement.focus();
  }
}
